import { AppSettings } from "../core/appsettings/appsettings";

const Home = {
  text: "navigation.links.customer.HOME",
  link: "/home",
  icon: "icon-home",
};
const CustomerOverview = {
  text: "navigation.links.admin.CUSTOMERMANGER",
  link: "/customer-manager",
  icon: "icon-people",
};
const CustomerManager = {
  text: "navigation.links.admin.SERVICEDIRECTORY",
  link: "/customer-manager",
  icon: "icon-user-follow",
  submenu: [
    {
      text: "navigation.links.admin.RESOURCEN",
      link: "/resource-manager",
    },

    {
      text: "navigation.links.admin.DEVICEMANAGER",
      link: "/device-manager",
    },
    {
      text: "navigation.links.admin.LICENSEMANAGER",
      link: "/license-manager",
    },
    {
      text: "navigation.links.admin.CONNECTORMANAGER",
      link: "/connector-manager",
    },
    {
      text: "navigation.links.admin.SubscriptionThirdPartyManager",
      link: "/subscription-manager",
    },
  ],
};

const Account = {
  text: "navigation.links.customer.profile.LABEL",
  link: "/userprofile",
  icon: "icon-user",
  submenu: [
    {
      text: "navigation.links.customer.profile.subcategories.ORGANIZATIONPROFILE",
      link: "/account/organizationprofile",
      breadcrumb: "breadcrumb.ORGANIZATIONPROFILE",
    },
    {
      text: "navigation.links.customer.profile.subcategories.PAYMENTS",
      link: "/account/paymentmethod",
    },
    {
      text: "navigation.links.customer.SUBSCRIPTION",
      link: "/account/subscription",
    },
    {
      text: "navigation.links.customer.profile.subcategories.USERS",
      link: "/account/user",
    },
    {
      text: "navigation.links.customer.profile.subcategories.ROLES",
      link: "/account/Roles",
    },
    {
      text: "navigation.links.customer.profile.subcategories.GROUPS",
      link: "/account/groups",
    },
    {
      text: "navigation.links.customer.profile.INVOICES",
      link: "/account/invoices",
    },
    {
      text: "navigation.links.customer.profile.subcategories.ACCOUNT",
      link: "/account/account",
    },
  ],
};

const Devices = {
  text: "navigation.links.customer.DEVICES",
  link: "/devices",
  icon: "icon-screen-tablet",
};
const Resources = {
  text: "navigation.links.customer.RESOURCES",
  link: "/resources",
  icon: "icon-calendar",
};

const Automation = {
  text: "navigation.links.customer.AUTOMATION",
  elink: AppSettings.AUTOMATION_URI,
  icon: "icon-equalizer",
};

const FloorPlan = {
  text: "navigation.links.customer.FLOORPLAN",
  link: "/maps",
  icon: "icon-map",
};

const Catering = {
  text: "navigation.links.customer.DEMANDS",
  link: "/room-service/category",
  icon: "icon-grid",
  tourAnchor: "roomService#1-menu-tab",
  submenu: [
    {
      text: "navigation.links.customer.CATEGORY",
      link: "/room-service/categories",
      tourAnchor: "roomService#2-categories-tab",
    },
    {
      text: "navigation.links.customer.ITEM",
      link: "/room-service/items",
      tourAnchor: "roomService#6-items-tab",
    },
  ],
};
const Insights = {
  text: "navigation.links.customer.INSIGHTS",
  link: "/insights-dashboard",
  icon: "icon-chart",
};

const Licenses = {
  text: "navigation.links.customer.LICENSES",
  link: "/licenses",
  icon: "icon-doc",
};

const Shop = {
  text: "navigation.links.customer.SHOP",
  link: "/shop",
  icon: "icon-basket",
  /*submenu: [
        {
            text: 'navigation.links.customer.SHOPLICENSES',
            link: '/shop',
            fragment: 'license'
        },
        {
            text: 'navigation.links.customer.SHOPHARDWARE',
            link: '/shop',
            fragment: 'hardware'
        },
    ]*/
};

const FAQ = {
  text: "navigation.links.customer.FAQ",
  elink: "https://docs.hxa.io",
  icon: "icon-question",
};

/* const Community = {
    text: 'navigation.links.customer.COMMUNITY',
    elink: 'https://community.hxa.io',
    icon: 'icon-question'
}; */

const Connectors = {
  icon: "icon-link",
  text: "navigation.links.customer.CONNECTOR",
  link: "/connector",
};

const Calendars = {
  icon: "icon-envelope",
  text: "navigation.links.customer.CALENDARS",
  link: "/calendars",
};

const Settings = {
  text: "navigation.links.customer.SETTINGS",
  link: "/settings",
  icon: "icon-settings",
  submenu: [
    /*{
            text: 'navigation.links.customer.CONNECTOR',
            link: '/settings/connector',
        },*/
    {
      text: "navigation.links.customer.LOGS",
      link: "/settings/logs",
    },
  ],
};

const AdminSettings = {
  text: "navigation.links.admin.ADMINSETTINGS",
  link: "/settings/products",
  icon: "icon-settings",
  submenu: [
    {
      text: "navigation.links.admin.PRODUCTS",
      link: "/settings/products",
    },
    {
      text: "navigation.links.admin.MESSAGECENTER",
      link: "/settings/messagecenter",
    },
    {
      text: "navigation.links.admin.EMAILLOGS",
      link: "/settings/emaillogs",
    },
  ],
};
const FeedbackReports = {
  text: "navigation.links.admin.FEEDBACK",
  link: "/feedback",
  icon: "icon-list",
};
// const headingMain = {
//   text: "sidebar.heading.HEADER",
//   heading: true,
// };
const News = {
  icon: "icon-bubble",
  text: "navigation.links.customer.NEWS",
  link: "/news-stream",
};
export const menu = [
  //headingMain,
  Home,
  CustomerOverview,
  CustomerManager,
  FAQ,
  AdminSettings,
  FeedbackReports,
];

export const usermenu = [
  //headingMain,
  Home,
  Account,
  Connectors,
  Calendars,
  Resources,
  Automation,
  FloorPlan,
  Catering,
  Insights,
  News,
  Devices,
  Licenses,
  Shop,
  FAQ,
  // Community,
  Settings,
];

export const resellermenu = [
  //headingMain,
  Home,
  CustomerManager,
  Devices,
  Licenses,
  Shop,
  FAQ,
];
